export const DENT_HISTORY_TYPE = {
	periodontal: 'patientTreatment.meddiDENT.dentalCross.periodontal.title',
	endodontic: 'patientTreatment.meddiDENT.dentalCross.endodontic.title',
	restoration: 'patientTreatment.meddiDENT.dentalCross.restoration',
	pathology: 'patientTreatment.meddiDENT.dentalCross.pathology',
};
